function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function normalizeFilterValue(value: unknown): unknown {
  if (typeof value !== 'string') return value
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/%/g, '')
}

export function normalizeFilterDTO(filterDTO: unknown): unknown {
  if (!isRecord(filterDTO) || !Array.isArray(filterDTO.filters)) return null
  return {
    ...filterDTO,
    filterLists: [],
    filters: filterDTO.filters.filter(isRecord).map((filter) => ({
      ...filter,
      values: Array.isArray(filter.values) ? filter.values.map(normalizeFilterValue) : filter.values,
    })),
  }
}
